import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=72fdf1fb&scoped=true&"
import script from "./Search.vue?vue&type=script&setup=true&lang=js&"
export * from "./Search.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fdf1fb",
  null
  
)

export default component.exports